<ng-container [ngSwitch]="type">
    <div
        role="progressbar"
        class="loader-ring__wrap"
        aria-valuemin="0"
        [attr.aria-valuenow]="progress"
        aria-label="Progress (in percentages)"
        aria-valuemax="100"
        *ngSwitchCase="'definite'"
    >
        <svg class="loader-ring" [attr.width]="ringRadius * 2" [attr.height]="ringRadius * 2">
            <circle
                class="loader-ring__inner"
                [attr.r]="ringNormalizedRadius"
                [attr.cx]="ringRadius"
                [attr.cy]="ringRadius"
            />
            <circle
                class="loader-ring__outer"
                [attr.stroke-width]="ringStroke"
                [attr.r]="ringNormalizedRadius"
                [attr.cx]="ringRadius"
                [attr.cy]="ringRadius"
                [ngStyle]="setRingStyles()"
            />
        </svg>
    </div>

    <span class="loader" *ngSwitchDefault>
        <span class="loader__dot1"></span>
        <span class="loader__dot2"></span>
        <span class="loader__dot3"></span>
    </span>

    <p *ngIf="label" class="loader__label">{{ label }}</p>
</ng-container>
